import { createSelector } from 'reselect';

import { Store } from '../reducers/reducers';

const announcementStateSelector = (store: Store) => store.announcements;

export const announcementByUuidSelector = (announcementUuid) =>
  createSelector(announcementStateSelector, (announcements) => announcements.find((announcement) => announcement.uuid === announcementUuid));

export const announcementToShowSelector = createSelector(announcementStateSelector, (announcements) =>
  announcements.filter((announcement) => !announcement.shown)
);
